<template>
  <v-container grid-list-lg>
    <v-card>
      <v-card-title class="primary white--text">
        <h2>Search</h2>
      </v-card-title>
      <v-card-text>
        <v-row wrap>
          <v-col xs6>
            <v-text-field
              v-model="searchString"
              label="Search"
              @keyup.enter="runSearch"
            >
            </v-text-field>
            <v-btn color="primary"
              @click="runSearch"
            >
              Search
            </v-btn>
          </v-col>
          <v-col>
            <v-select
              v-model="field"
              :items="items"
              label="Field"
            >
            </v-select>
          </v-col>
        </v-row>

        <v-divider class="my-2"></v-divider>

        <div
          v-for="(result, ind) in results"
          :key="ind"
        >
          <a
            href=""
            @click.prevent="viewResult(result.uri)"
          >
            {{ result.title }}
          </a>
          <br/>
        </div>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
  data () {
    return {
      field: '',
      items: [
        {
          text: 'All',
          value: ''
        },
        {
          text: 'Tags',
          value: 'tags'
        },
        {
          text: 'Title',
          value: 'title'
        },
        {
          text: 'Content',
          value: 'content'
        }
      ]
    }
  },
  computed: {
    ...mapState('article', {
      results: state => state.searchResults
    }),
    searchString: {
      get () {
        return this.$store.state.article.searchString
      },
      set (val) {
        this.$store.commit('article/setSearchString', val)
      }
    }
  },
  methods: {
    ...mapActions('article/transactions', [
      'searchAction'
    ]),
    viewResult (uri) {
      this.$router.push(`/wiki/${uri}`)
    },
    runSearch () {
      this.searchAction(this.field)
    }
  }
}
</script>

<style>

</style>
